import posthog from 'posthog-js';

// PostHog configuration
const posthogConfig = {
  api_host: process.env.REACT_APP_POSTHOG_HOST || 'https://app.posthog.com',
  person_profiles: 'identified_only', // Only create profiles for identified users
  capture_pageview: false, // We'll handle pageviews manually
  capture_pageleave: true,
  loaded: (posthog) => {
    if (process.env.NODE_ENV === 'development') {
      console.log('🔍 PostHog loaded successfully');
    }
  }
};

// Initialize PostHog
export const initPostHog = () => {
  const apiKey = process.env.REACT_APP_POSTHOG_API_KEY;
  
  if (!apiKey) {
    console.warn('⚠️ PostHog API key not found. Analytics will be disabled.');
    return;
  }

  if (typeof window !== 'undefined') {
    posthog.init(apiKey, posthogConfig);
  }
};

// PostHog event tracking functions
export const trackEvent = (eventName, properties = {}) => {
  if (typeof window !== 'undefined' && posthog) {
    posthog.capture(eventName, {
      ...properties,
      timestamp: new Date().toISOString(),
      environment: process.env.REACT_APP_ENVIRONMENT || 'development'
    });
  }
};

// Track bridge transactions
export const trackBridgeTransaction = (transactionData) => {
  trackEvent('bridge_transaction', {
    source_network: transactionData.sourceNetwork,
    dest_network: transactionData.destNetwork,
    token_symbol: transactionData.tokenSymbol,
    amount: transactionData.amount,
    transaction_hash: transactionData.txHash,
    user_address: transactionData.userAddress
  });
};

// Track wallet connections
export const trackWalletConnection = (walletData) => {
  trackEvent('wallet_connected', {
    wallet_type: walletData.walletType,
    network: walletData.network,
    user_address: walletData.userAddress
  });
};

// Track admin actions
export const trackAdminAction = (actionData) => {
  trackEvent('admin_action', {
    action_type: actionData.actionType,
    network: actionData.network,
    admin_address: actionData.adminAddress,
    details: actionData.details
  });
};

// Track errors
export const trackError = (errorData) => {
  trackEvent('error_occurred', {
    error_type: errorData.errorType,
    error_message: errorData.errorMessage,
    component: errorData.component,
    user_address: errorData.userAddress
  });
};

// Track page views
export const trackPageView = (pageName, properties = {}) => {
  trackEvent('page_viewed', {
    page_name: pageName,
    ...properties
  });
};

// Identify user
export const identifyUser = (userAddress, userProperties = {}) => {
  if (typeof window !== 'undefined' && posthog && userAddress) {
    posthog.identify(userAddress, {
      address: userAddress,
      ...userProperties
    });
  }
};

// Reset user (on logout)
export const resetUser = () => {
  if (typeof window !== 'undefined' && posthog) {
    posthog.reset();
  }
};

export default posthog;
